import { Base, createApp } from '@studiometa/js-toolkit';

/**
 * CollectionFilter component
 */
class CollectionFilter extends Base {
  /**
   * Component configuration
   */
  static config = {
    name: 'CollectionFilter',
  }

  /**
   * Mounted lifecycle hook
   */
  mounted() {
    console.log('CollectionFilter mounted');
    const filterButtons = document.querySelectorAll('.collections-filter__button');
    const collectionItems = document.querySelectorAll('.page-collections__item');
    
    filterButtons.forEach(button => {
      button.addEventListener('click', () => {
        filterButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
        
        const filter = button.getAttribute('data-filter');
        
        collectionItems.forEach(item => {
          if (filter === 'all') {
            item.style.display = 'block';
          } else {
            const itemGroup = item.getAttribute('data-group');
            if (itemGroup === filter) {
              item.style.display = 'block';
            } else {
              item.style.display = 'none';
            }
          }
        });
      });
    });
  }
}

// Initialize the component
createApp(CollectionFilter, document.body);

